import { pageId } from '@/config'
export default {
  install(Vue) {
    // 应用页面唯一的id
    Vue.prototype.$pageId = pageId
  }
}
